import React, { useState, useEffect } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  AttachedTable,
  EldritchInvocationsFeature,
  UpgradableNumber,
} from "@dndModels";

import UpgradableNumberBox from "@dndComponents/UpgradableNumberBox";
import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";

interface Props { 
  obj: EldritchInvocationsFeature;
  onChange: (changed: EldritchInvocationsFeature) => void;
  disabled?: boolean;
  attached_table?: AttachedTable;
}

export default function EldritchInvocationsFeatureInput({ 
  obj,
  attached_table,
  onChange,
  disabled = false 
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [myObj, setMyObj] = useState(obj.clone());
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 6
        }}>
        <UpgradableNumberBox 
          name="Eldritch Invocation Count"
          value={myObj.count} 
          disabled={disabled}
          attached_table={attached_table}
          onChange={(changed: UpgradableNumber) => {
            const floating_feature = myObj;
            floating_feature.count = changed.clone();
            setMyObj(floating_feature);
            onChange(floating_feature);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <SelectObjectBox 
          name="Eldritch Invocations"
          data_type="eldritch_invocation"
          values={myObj.ei_ids} 
          disabled={disabled}
          multiple
          onChange={(changed: string[]) => {
            const floating_feature = myObj;
            floating_feature.ei_ids = changed;
            setMyObj(floating_feature);
            onChange(floating_feature);
          }}
        />
      </Grid>
    </Grid>
  );
}
